export const inputCls =
  "w-full px-3 py-2 text-sm border border-border rounded-lg bg-surface text-text_primary " +
  "placeholder:text-text_muted focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-colors";

export const DATE_FORMATS = ["DD/MM/YYYY", "MM/DD/YYYY", "YYYY-MM-DD", "DD-MM-YYYY"];

export const TIME_FORMATS = [
  { value: "24", label: "24-hour (14:30)" },
  { value: "12", label: "12-hour (2:30 PM)" },
];

export const THEME_OPTIONS = [
  { value: "LIGHT", label: "Light" },
  { value: "DARK", label: "Dark" },
  { value: "SYSTEM", label: "Match system" },
];

export const WORKING_DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export const buildSettingsFormState = (s) => ({
  timezone_fid: s?.timezone_fid ?? "",
  currency_fid: s?.currency_fid ?? "",
  date_format: s?.date_format || "DD-MM-YYYY",
  time_format: s?.time_format || "12",
  theme: s?.theme || "SYSTEM",
  projects_per_page: s?.projects_per_page ?? 20,
  show_completed_projects: s?.show_completed_projects ?? true,
  working_hours_start: s?.working_hours_start || "09:00",
  working_hours_end: s?.working_hours_end || "18:00",
  working_days: s?.working_days || ["Mon", "Tue", "Wed", "Thu", "Fri"],
  email_notifications: s?.email_notifications ?? true,
  push_notifications: s?.push_notifications ?? true,
  notify_project_assigned: s?.notify_project_assigned ?? true,
  notify_project_completed: s?.notify_project_completed ?? true,
  notify_project_comment: s?.notify_project_comment ?? true,
  notify_project_due: s?.notify_project_due ?? true,
  notify_project_updates: s?.notify_project_updates ?? true,
  notify_mentions: s?.notify_mentions ?? true,
  notify_daily_summary: s?.notify_daily_summary ?? false,
  notify_weekly_summary: s?.notify_weekly_summary ?? true,
  show_online_status: s?.show_online_status ?? true,
  show_email: s?.show_email ?? false,
  show_phone: s?.show_phone ?? false,
});

// Fields to send on save — id/timestamps/relations stay server-side.
export const SETTINGS_FIELDS = Object.keys(buildSettingsFormState());

export const SectionShell = ({ icon: Icon, title, subtitle, id, children }) => (
  <div id={id} className="bg-surface rounded-xl border border-border shadow-sm overflow-hidden scroll-mt-5">
    <div className="h-[3px] bg-gradient-to-r from-primary to-secondary/60" />
    <div className="p-5">
      <div className="flex items-center gap-2.5 mb-5">
        <div className="w-8 h-8 rounded-lg bg-primary/[0.09] flex items-center justify-center shrink-0 ring-1 ring-primary/10">
          <Icon size={13} className="text-primary" />
        </div>
        <div>
          <h3 className="text-[13px] font-semibold text-text_primary">{title}</h3>
          {subtitle && <p className="text-[11px] text-text_muted mt-0.5">{subtitle}</p>}
        </div>
      </div>
      {children}
    </div>
  </div>
);

export const ToggleRow = ({ label, description, children }) => (
  <div className="flex items-center justify-between gap-3 py-2.5 border-b border-border/60 last:border-0">
    <div className="min-w-0">
      <p className="text-xs font-medium text-text_primary">{label}</p>
      {description && <p className="text-[11px] text-text_muted mt-0.5">{description}</p>}
    </div>
    {children}
  </div>
);
